"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftStatus = void 0;
exports.instanceOfShiftStatus = instanceOfShiftStatus;
exports.ShiftStatusFromJSON = ShiftStatusFromJSON;
exports.ShiftStatusFromJSONTyped = ShiftStatusFromJSONTyped;
exports.ShiftStatusToJSON = ShiftStatusToJSON;
exports.ShiftStatusToJSONTyped = ShiftStatusToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftStatus = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED'
};
function instanceOfShiftStatus(value) {
    for (const key in exports.ShiftStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftStatus, key)) {
            if (exports.ShiftStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftStatusFromJSON(json) {
    return ShiftStatusFromJSONTyped(json, false);
}
function ShiftStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftStatusToJSON(value) {
    return value;
}
function ShiftStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftStatus.js.map